import dayjs from "dayjs"
import React, { useEffect, useRef, useState } from "react"

const DateTime = () => {
  const [date, setDate] = useState("")
  const intervalRef = useRef<NodeJS.Timeout>()
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      let d = dayjs(new Date()).format("YYYY年MM月DD日(ddd) HH:mm")
      setDate(d)
    }, 1000)

    return () => {
      if (intervalRef && intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])
  return <span>{date}</span>
}

export default DateTime
